import React from 'react';
import { connect } from 'react-redux';
import {
	onStartPreloadEditor,
	onPreloadEditorFinish,
} from '@confluence-classic/confluence-fabric-editor/src/actions/legacy-editor';

import EditorLoaderComponent from './EditorLoaderComponent';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
	onStartPreloadEditor: (contentId) => dispatch(onStartPreloadEditor({ contentId })),
	onPreloadEditorFinish: (contentId) => dispatch(onPreloadEditorFinish({ contentId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditorLoaderComponent);
